<template>
  <div class="manufacture-details">
    <div class="position-relative form-group details w-100">
      <h2>
        {{ data.name }}
        <i class="ti ti-printer mr-1 print-content" @click.prevent="handlePrint"></i>
      </h2>
      <span v-html="this.$util.timestampToDateTime(parseInt(data.date_created))" class="col-6 date-created"></span>
      <div :class="`col-6 pr-0 manufacture-status flag text-right ${data.status}`">
        <span class="m-0">{{ listStatus[data.status] != undefined ? listStatus[data.status].label : '' }}</span>
      </div>
    </div>

    <Status :config="{ storeId, manufactureId, data, loaded: config.loaded }" @close="$emit('close', $event)"></Status>

    <div class="attribute w-100">
      <div class="description w-100">
        <div v-if="$_.isArray(data.designs) && data.designs.length > 0" class="form-group">
          <label class="col-12 mb-0 p-0">Blueprint:</label>
          <ul class="list-blueprint">
            <li v-for="(url, index) in data.designs" :key="index" :class="`ext ext-${this.$util.getExtensionFromString(url)}`">
              <a :href="url" @click.prevent="handeClickBlueprint(url)">{{ this.$util.getExtensionFromString(url) ?? 'Link' }}</a>
            </li>
          </ul>
        </div>
        <div class="form-group mt-2">
          <label class="col-12 mb-0 p-0">Artwork:</label>
          <ul class="list-blueprint">
            <li v-if="artworks.front" :class="`ext ext-${this.$util.getExtensionFromString(artworks.front)}`">
              <a :href="artworks.front" @click.prevent="handeClickBlueprint(artworks.front)">Front</a>
            </li>
            <li v-if="artworks.back" :class="`ext ext-${this.$util.getExtensionFromString(artworks.back)}`">
              <a :href="artworks.back" @click.prevent="handeClickBlueprint(artworks.back)">Back</a>
            </li>
            <li v-if="artworks.cut" :class="`ext ext-${this.$util.getExtensionFromString(artworks.cut)}`">
              <a :href="artworks.cut" @click.prevent="handeClickBlueprint(artworks.cut)">Cut</a>
            </li>
          </ul>
        </div>
        <div class="form-group">
          <label class="col-12 mb-0 p-0">Shop Name: </label>
          <span class="select-all">{{ data.account_name }}</span>
        </div>
        <div class="form-group">
          <label class="col-12 mb-0 p-0">Manufacturer: </label>
          <span class="select-all">{{ data.manufacturer_name }}</span>
        </div>
      </div>

      <template v-if="$_.isObjectLike(data.attributes)">
        <div v-for="(attribute, index) in data.attributes" :key="index" :class="`form-group ${index}`">
          <label class="col-12 mb-0 p-0 text-capitalize">{{ data.more.attributes[index] ? data.more.attributes[index].label : index }}: </label>
          <span class="select-all">{{ attribute }}</span>
        </div>
      </template>
      <div v-if="data.quantity" class="form-group">
        <label class="col-12 mb-0 p-0">Quantity: </label>
        <span class="select-all">{{ data.quantity }}</span>
      </div>
      <div v-if="$_.isArray(data.note) && data.note.length > 0" class="form-group">
        <label class="col-12 mb-0 p-0">Note</label>
        <ul class="notes">
          <template v-for="(note, index) in data.note" :key="index">
            <li v-if="String(note).length > 0" v-html="$util.autoLink(note)"></li>
          </template>
        </ul>
      </div>
    </div>
    <hr />
  </div>
</template>

<script>
import Status from './Status.vue'
import Event from '@/helper/event.js'
import print from '@/helper/print.js'
export default {
  mixins: [Event],
  components: {
    Status
  },
  computed: {
    storeId() {
      return this.config?.storeId
    },
    manufactureId() {
      return this.config?.manufactureId
    },
    data() {
      return this.config?.data
    },
    more() {
      return this.data.more || {}
    },
    listStatus() {
      return this.more?.options?.statuses || {}
    },
    artworks() {
      const art = this.data?.artworks || {}
      return {
        front: art.front || art.artwork_front || this.data?.artwork_front,
        back: art.back || art.artwork_back || this.data?.artwork_back,
        cut: art.cut || art.artwork_cut || this.data?.artwork_cut
      }
    },
    hasArtworks() {
      return this.artworks.front || this.artworks.back || this.artworks.cut
    }
  },
  methods: {
    handeClickBlueprint(url) {
      if (Object.keys(this.$util.options.extension.image).includes(this.$util.getExtensionFromString(url))) {
        window.open(url, '_blank')
      } else if (this.more?.options?.open_blueprint == 'modal') {
        this.$emitter.emit('SubModal', {
          name: 'full-screen-image-preview',
          data: {
            files: [url],
            thumbnail: true,
            background: true
          }
        })
      } else if (this.more?.options?.open_blueprint == 'next_to') {
        this.$emit('change-preview', url)
      } else {
        window.open('/preview?attached=' + encodeURIComponent(url), '_blank')
      }
    },
    handlePrint() {
      let order = _.cloneDeep(this.data.refer_order)
      order.manufacturer = this.item?.manufacturer?.user_name
      order.line_items = _.filter(order.line_items, (item) => {
        return this.data?.product_identify == item.identify
      })
      print.order(order)
    }
  },
  props: {
    config: Object
  }
}
</script>
<style lang="scss">
h2 {
  .print-content {
    cursor: pointer;
    display: none;
  }
  &:hover {
    .print-content {
      display: inline-block;
    }
  }
}
</style>
